export default __webpack_public_path__ + "static/media/ilustracao-ferramentas.792e4141.png";